/**
 * Display the die number and description returned by the Die Number Lookup
 * query that is stored in dynamicInputResult field of the request
 * @param {Local.DieNumberLookupProps} props
 */
export const DieNumberLookup = ({ result }) => {
  if (!result?.die && !result?.description) return null;
  return <span data-testid='dynamic-input-result'>{`Description: ${result.description} DIE: ${result.die}`}</span>;
};
